<template>
  <div>
    <h4>Cartão de Crédito</h4>
    <CreditCardCustomerFields :basket="basket" />

    <vs-button type="relief" class="w-full mt-6" @click="next()">Continuar</vs-button>
  </div>
</template>

<script>
import CreditCardCustomerFields from '../CreditCardCustomerFields.vue';
import { checkoutLog } from '../../utils/checkoutDebug';

export default {
  components: {
    CreditCardCustomerFields
  },
  props: {
    checkoutWizard: {
      type: Object,
      required: true
    },
    paymentMethod: {
      type: String,
      required: true
    },
    basket: {
      type: Object,
      required: true
    }
  },
  mounted() {
    checkoutLog('gateway:mounted', { gateway: 'CreditCardIugu', paymentMethod: this.paymentMethod }, this.$route);
  },
  methods: {
    next() {
      this.basket.processing = true;

      this.$api
        .post('/api/v1/checkout/order/create', {
          payment_method: this.paymentMethod,
          basket: this.basket,
          affiliate: localStorage.getItem('aff') || null
        })
        .then(response => {
          window.location = response.data.url;
        })
        .catch(error => {
          this.basket.processing = false;
          this.$EventBus.$emit('paymentProviderFailed', this.paymentMethod);

          let errors = [];
          if (error.response && error.response.data.message) {
            errors.push(error.response.data.message);
          } else if (error.response) {
            for (const key in error.response.data) {
              if (Object.hasOwnProperty.call(error.response.data, key)) {
                errors.push(error.response.data[key]);
              }
            }
          }

          this.$vs.notify({
            time: 6000,
            text: errors.join('<br>'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    }
  }
};
</script>
